@if (announces?.myNotificationsUnread?.length > 0 || announces?.myNotificationsRead?.length > 0) {
<!-- Reste affiché quand tout est lu, en ton neutre : on doit pouvoir retrouver
     les annonces encore actives sans qu'elles se fassent passer pour des nouveautés. -->
<div [class.announces-banner--read]="!announces.myNotificationsUnread.length" class="announces-banner">
  <button (click)="toggle()" [attr.aria-expanded]="expanded" class="announces-banner-summary" type="button">
    <i class="fal fa-bell"></i>
    <span>
      @if (announces.myNotificationsUnread.length) {
      <b>{{ announces.myNotificationsUnread.length }}</b>
      annonce{{ announces.myNotificationsUnread.length > 1 ? 's' : '' }} non lue{{ announces.myNotificationsUnread.length > 1 ? 's' : '' }}
      — {{ announces.myNotificationsUnread[0].title }}
      } @else {
      <b>{{ announces.myNotificationsRead.length }}</b>
      annonce{{ announces.myNotificationsRead.length > 1 ? 's' : '' }} active{{ announces.myNotificationsRead.length > 1 ? 's' : '' }}
      }
    </span>
    <i class="fal announces-banner-chevron" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>
  @if (expanded) {
  <ul class="announces-banner-list">
    @for (a of announces.myNotificationsUnread; track a.id) {
    <li>
      <a class="announces-banner-item-link" [routerLink]="['/annonce', a.id]">{{ a.title }}</a>
      <button type="button" class="announces-banner-mark-read" title="Marquer comme lue" (click)="markAsRead(a)">
        <i class="fal fa-check"></i>
      </button>
    </li>
    }
    @for (a of announces.myNotificationsRead; track a.id) {
    <li>
      <a [routerLink]="['/annonce', a.id]" class="announces-banner-item-link announces-banner-item-link--read">{{ a.title }}</a>
    </li>
    }
  </ul>
  <a class="announces-banner-viewall" [routerLink]="['/annonce']">Voir toutes les annonces →</a>
  }
</div>
}
